import { render } from "./WaitingProducts.vue?vue&type=template&id=82ff496c"
import script from "./WaitingProducts.vue?vue&type=script&lang=js"
export * from "./WaitingProducts.vue?vue&type=script&lang=js"

import "./WaitingProducts.vue?vue&type=style&index=0&id=82ff496c&lang=css"

import exportComponent from "C:\\Users\\oozdemir\\Documents\\GitHub\\bootstrap-sample\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__